export enum BlockReasonType {
  None = 0,
  SelfExclusionMatch = 1,
  SimilarUserExist = 2,
  LoginAttemptsExceeded = 3,
  MultipleAccounts = 4,
  BonusAbuse = 5,
  SuspectedFraud = 6,
  ConfirmedFraud = 7,
  FalseRegistration = 8,
  Underage = 9,
  Other = 10,
  SelfExclusion = 11,
  Timeout = 12,
  PropagatedSelfExclusion = 13,
  PoliticallyExposedPerson = 14,
  UnverifiedAccount = 15,
  MaliciousActivity = 16,
  GamstopMatch = 17,
  MarketClosure = 18,
  AccountClosure = 19,
  OfflineBlock = 20,
  OfflineSelfExclusion = 21,
  DgeExclusionMatch = 22,
  OFAC = 23,
  DormantAccountClosure = 24,
  ACHFailures = 25,
  DevCodeDispute = 26,
  PanicTimeout = 27,
  PanicSelfExclusion = 28,
  SwedenSelfExclusionRegister = 29,
  HiddenIdentity = 30,
  DgojVerificationMatch = 31,
  AccountInactive = 32,
  Deceased = 33,
  PermanentAccountClosure = 34,
  OverdueUnverifiedAccount = 35,
  LatviaSelfExclusionRegister = 36,
  InactivityClosure = 37,
  GermanSelfExclusionRegister = 38,
  CFTSanction = 39,
  SelfExclusionRegisterIsDown = 40,
}
